import axios from 'axios'
import { RecordAltFind } from '@core/js/helpers/functions'
import _ from 'lodash'

const state = {
  lines: [],
  total: 0,
  count_qty: 0,
  count_lines: 0,
  tax_total: 0,
}

const getters = {
  basketTotal(state) {
    return state.total
  },
  basketQty(state) {
    return state.count_qty
  },
  basketTotalLines(state) {
    return state.count_lines
  },
  taxTotal(state) {
    return state.tax_total
  },
  basketCount(state) {
    var count = 0
    if (state.lines.length > 0) {
      state.lines.forEach((line, index) => {
        count += Number(line.quantity)
      })
    }
    return count
  },
}

const mutations = {
  setLines(state, lines) {
    state.lines = lines
  },
  setTotal(state, total) {
    state.total = total
  },
  setCountQty(state, value) {
    state.count_qty = value
  },
  setCountLines(state, value) {
    state.count_lines = value
  },
  setTaxTotal(state, taxTotal) {
    state.tax_total = taxTotal
  },
  addLine(state, record) {
    state.lines.push(record)
  },
  removeLine(state, item) {
    const index = state.lines.findIndex((line) => line.id === item.id)
    state.lines.splice(index, 1)
  },
  emptyCart(state, record) {
    state.lines = []
    state.total = 0
    state.count_qty = 0
    state.count_lines = 0
    state.tax_total = 0
  },
}

const actions = {
  addToBasket({ commit, dispatch, state }, record) {
    const recordLine = RecordAltFind(state.lines, (line) => {
      return line.record_id === record.record_id
    })
    commit('emptyCart', record)
    if (!recordLine) {
      // Add new plan to basket
      commit('addLine', record)
    } else {
      commit('removeLine', record)
      // commit('removePlanLine', record)
      commit('addLine', record)
    }

    // Update basket
    return dispatch('updateBasket')
  },
  updateBasket({ commit, state }) {
    state.lines = _.filter(state.lines, (item) => {
      return item.quantity > 0
    })

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/basket/update',
        data: { basketData: state },
        responseType: 'json',
      })
        .then((response) => {
          commit('setLines', response.data.lines)
          commit('setTotal', response.data.total)
          commit('setCountQty', response.data.count_qty)
          commit('setCountLines', response.data.count)
          commit('setTaxTotal', response.data.tax_total)
          resolve(response)
          //window.location.href = '/account/cart'
          window.location.href = '/account/checkout'
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getBasket({ commit, state }) {
    /* eslint-disable no-unused-vars */
    let basket = axios.get('/basket/get').then((response) => {
      if (response.data && response.data.lines) {
        commit('setLines', response.data.lines)
        commit('setCountQty', response.data.count_qty)
        commit('setCountLines', response.data.count)
        commit('setTaxTotal', response.data.tax_total)
        commit('setTotal', response.data.total)
      }
    })
    /* eslint-enable no-unused-vars */
  },
  removeFromBasket({ commit, dispatch }, line) {
    commit('removeLine', line)
    return dispatch('updateBasket')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
